var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3 custom-callout",
      attrs: {
        "border-color": _vm.getEditDistributionColor,
        "has-toggle": false
      }
    },
    [
      _c(
        "validation-observer",
        {
          ref: "editDistributionNumber",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col mt-4" },
              [
                _c("icon-view", {
                  attrs: {
                    icon: "fa fa-edit",
                    "icon-background": "#fff",
                    "icon-color": "#2DB782",
                    title: "Modificación de la Distribución de Cifras de Cuenta"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row mt-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-md-3 col-sm-12 col-spacing service-place-spacing"
              },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              id: "ageGroupDd",
                              clearable: false,
                              "custom-error-msg":
                                "El grupo de edad es requerido.",
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Grupo de Edad:",
                              options: _vm.ageGroupList,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.ageGroup,
                              callback: function($$v) {
                                _vm.ageGroup = $$v
                              },
                              expression: "ageGroup"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-sm-12 col-spacing" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              id: "oldPurchaseOrderIdDd",
                              clearable: false,
                              "custom-error-msg":
                                "El número de Grant actual es requerido.",
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Número de Grant actual:",
                              options: _vm.purchaseOrdersInBill,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.oldPurchaseOrderId,
                              callback: function($$v) {
                                _vm.oldPurchaseOrderId = $$v
                              },
                              expression: "oldPurchaseOrderId"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-md-1 col-sm-12 d-none d-md-flex align-items-end justify-content-center"
              },
              [
                _c("div", { staticClass: "icon" }, [
                  _c("span", { staticClass: "dot text-center py-2 px-1" }, [
                    _c("i", {
                      staticClass:
                        "orange-icon orange-icon-badge-align fas fa-arrow-circle-right"
                    })
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-sm-12 col-spacing" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            attrs: {
                              id: "newPurchaseOrderIdDd",
                              clearable: false,
                              "custom-error-msg":
                                "El número de Grant a modificar es requerido.",
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Número de Grant a modificar:",
                              options: _vm.purchaseOrders,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.newPurchaseOrderId,
                              callback: function($$v) {
                                _vm.newPurchaseOrderId = $$v
                              },
                              expression: "newPurchaseOrderId"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col d-flex d-md-block d-sm-flex mt-5 text-right"
              },
              [
                _c(
                  "action-button",
                  {
                    attrs: {
                      id: "cancelEditBtn",
                      i: "fas fa-times-circle",
                      variant: "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                    },
                    on: { click: _vm.cancelEdit }
                  },
                  [_vm._v(" Cancelar ")]
                ),
                _c(
                  "action-button",
                  {
                    attrs: {
                      id: "editDistributionNumberBtn",
                      i: "fas fa-sync-alt",
                      variant: "success pl-4 pr-4"
                    },
                    on: { click: _vm.editDistributionNumber }
                  },
                  [_vm._v(" Actualizar ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }